module.exports = __webpack_public_path__ + "img/ico_footprint.dca7c863.svg";